import type { OrderDetails } from '../model'

/**
 * Gets the field value from hsFields by matching the key with a case-insensitive regex (explicit/full match).
 */
export function getFieldValueByRegex(
  hsFields: OrderDetails['hsFields'] | undefined,
  regex: RegExp,
): string | undefined {
  if (!hsFields)
    return undefined
  for (const key of Object.keys(hsFields)) {
    if (typeof key === 'string' && regex.test(key) && hsFields[key]) {
      // Only return if the key matches the regex exactly (full match)
      if (key.match(regex)?.[0] === key) {
        return hsFields[key]
      }
    }
  }
  return undefined
}

/**
 * Gets the field value from hsFields based on a list of possible keys.
 * Useful for retrieving values that may have different naming conventions.
 */
export function getFieldValue(
  hsFields: OrderDetails['hsFields'] | undefined,
  possibleKeys: string[],
): string | undefined {
  if (!hsFields)
    return undefined
  for (const key of possibleKeys) {
    if (hsFields[key])
      return hsFields[key]
  }
  return undefined
}

/**
 * @name getDriverName
 */
export function getDriverName(hsFields: OrderDetails['hsFields']): string | undefined {
  return getFieldValueByRegex(hsFields, /^(driver name|drivername)$/i) || hsFields?.driverName
}

/**
 * @name getOrderType
 */
export function getOrderType(hsFields: OrderDetails['hsFields']): string | undefined {
  return getFieldValueByRegex(hsFields, /^(order type)$/i)
}

/**
 * @name getRestricted
 */
export function getRestricted(hsFields: OrderDetails['hsFields']): string | undefined {
  return getFieldValueByRegex(hsFields, /^(restricted)$/i)
}
